import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import styles from './Filters.module.scss';
const Filters = ({ children, filter }) => {
    return _jsx("div", Object.assign({ className: cn(styles.element, filter && styles.open) }, { children: children }));
};
export default Filters;
